

import "./rateCard.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCategoryList } from "../resourceCommonAPIs";
import {
  getItemTypeList,
  getAllRateCard,
  editRateCard,
  deleteRateCard,
  fetchStakeholderRateCardStatus,
  fetchBudgetApprovalRole,
} from "./rateCardAPIs";
import {
  handleNumberFieldFocus,
  titleCase,
} from "../../../common/commonFunction";
import {
  CATEGORY_ERROR,
  ITEM_TYPE_ERROR,
  VIEW_OR_EDIT_RATE_CARD,
  VEHICLE_CAPACITY,
  STAKEHOLDER_URN,
  STAKEHOLDER_NAME,
  REGISTRATION_NO,
  VEHICLE_TYPE,
  VEHICLE_MAKE,
  VEHICLE_MODEL,
  ROUTE,
  LAND_NAME,
  ITEM_RATE,
  CATEGORY,
  ITEM_TYPE,
  ROUTE_TYPE,
  STATE,
  DISTRICT,
  REVENUE_CIRCLE,
  UNIT_PER,
  NO_DATA_AVAILABLE,
  PROCEED,
  LLE,
} from "../../../common/constants";
import { Button, Card, IconButton, Tab, Tooltip } from "@mui/material";
import TrashIcon from "../../../images/TrashIcon.png";
import { PROD } from "../../../common/constants";
import {
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import BackButton from "../../../common/backButton";
import CustomDataGridToolbar from "../../../common/customDataGridToolbar";
import { DataGrid } from "@mui/x-data-grid";
import { format } from "date-fns";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { toast } from "react-toastify";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Dialog from "@mui/material/Dialog";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Badge from "react-bootstrap/Badge";
import {
  VALIDATION,
  mobileNoMaxLength,
  urnMaxLength,
} from "../../../common/commonValidations";
import { DeleteIcon, ProceedIcon } from "../../../common/icons";
import BadgeComponent from "../../../common/badge";

function EditRateCard() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [categoryList, setCategoryList] = useState();
  const [itemTypeList, setItemTypeList] = useState();
  const [editRateCardResponse, setEditRateCardResponse] = useState();
  const [showData, setShowData] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [tabValue, setTabValue] = useState("0");
  const [tab2Value, setTab2Value] = useState("rateCardStatus");
  const [rateCardStatusResponse, setRateCardStatusResponse] = useState();
  const [budgetApprovalRole, setBudgetApprovalRole] = useState();
  const [tobeDeleted, setTobeDeleted] = useState();
  const [details, setDetails] = useState({
    urn: "",
  });
  const [showRateCardData, setShowRateCardData] = useState(false);
  const [approvalBudget, setApprovalBudget] = useState();
  const [selectCategoryAndType, setSelectCategoryAndType] = useState({
    category: null,
    itemType: null,
  });
  const [errorMessage, setErrorMessage] = useState({
    categoryError: "",
    itemTypeError: "",
    urnError: "",
  });
  const [rateCardDetails, setRateCardDetails] = useState({
    category: null,
    itemType: null,
    urnNumber: null,
    itemRate: null,
    vehicleType: null,
    vehicleCapacity: null,
    routeId: null,
  });
  const [rateCardDetailsArr, setRateCardDetailsArr] = useState([]);
  const [filteredRateCardDetailsArr, setFilteredRateCardDetailsArr] =
    useState();
  const [filterTable, setFilterTable] = useState({
    urnNumber: "",
    name: "",
    revenueCircle: "",
    lleName: "",
  });

  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [submitItem, setSubmitItem] = useState();
  const [open, setOpen] = useState(false);
  const [characterLimit] = useState(500);
  const [addComment, setAddComment] = useState("");

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => {
    setAddComment("");
    setLogModalOpen(false);
  };

  useEffect(() => {
    getCategoryList(setCategoryList);
    getItemTypeList(setItemTypeList);
  }, []);

  useEffect(() => {
    setSelectCategoryAndType({
      ...selectCategoryAndType,
      itemType: null,
    });
    setRateCardDetailsArr([]);
  }, [selectCategoryAndType?.category]);

  useEffect(() => {
    setRateCardDetailsArr([]);
  }, [selectCategoryAndType?.itemType]);

  useEffect(() => {
    if (
      filterTable.urnNumber ||
      filterTable.name ||
      filterTable.revenueCircle ||
      filterTable.lleName
    ) {
      const filteredRateCardDetails =
        rateCardDetailsArr &&
        rateCardDetailsArr?.filter((item) => {
          let keep = true;
          if (filterTable.urnNumber) {
            keep =
              keep &&
              item.urnNumber
                ?.toLowerCase()
                ?.includes(filterTable?.urnNumber.toLowerCase().trim());
          }
          if (filterTable.name) {
            keep =
              keep &&
              item.name
                ?.toLowerCase()
                ?.includes(filterTable?.name.toLowerCase().trim());
          }
          if (filterTable.revenueCircle) {
            keep =
              keep &&
              item.revenueCircle
                ?.toLowerCase()
                ?.includes(filterTable?.revenueCircle.toLowerCase().trim());
          }
          if (filterTable.lleName) {
            keep =
              keep &&
              item.lleName
                ?.toLowerCase()
                ?.includes(filterTable?.lleName.toLowerCase().trim());
          }
          return keep;
        });
      setFilteredRateCardDetailsArr(filteredRateCardDetails);
    } else {
      setFilteredRateCardDetailsArr();
    }
  }, [
    filterTable.urnNumber,
    filterTable.name,
    filterTable.revenueCircle,
    filterTable.lleName,
  ]);

  useEffect(() => {
    if (editRateCardResponse) {
      if (editRateCardResponse?.status === "SUCCESS") {
        toast.success(editRateCardResponse?.description);
        // navigate('../home')
      } else toast.error(editRateCardResponse?.description);
    }
    setRateCardDetails(null);
    getAllRateCard(selectCategoryAndType, setRateCardDetailsArr);
  }, [editRateCardResponse]);

  const handleChange = (e) => {
    e.target.name &&
      setSelectCategoryAndType({
        ...selectCategoryAndType,
        [e.target.name]: e.target.value,
      });
    setSubmit(false);
    if (e.target.name === "category") {
      setErrorMessage({ ...errorMessage, categoryError: "" });
    }
    if (e.target.name === "itemType") {
      setErrorMessage({ ...errorMessage, itemTypeError: "" });
    }
    if (e.target.name === "itemRate") {
      setRateCardDetails({
        ...rateCardDetails,
        [e.target.name]: e.target.value,
      });
    }
    if (e.target.name === "routeId") {
      setRateCardDetails({
        ...rateCardDetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  const onProceedViewRateCardTable = (e) => {
    e.preventDefault();
    setSubmit(true);
    if (!selectCategoryAndType?.category) {
      setErrorMessage({ ...errorMessage, categoryError: { CATEGORY_ERROR } });
    } else if (!selectCategoryAndType?.itemType) {
      setErrorMessage({ ...errorMessage, itemTypeError: { ITEM_TYPE_ERROR } });
    } else {
      getAllRateCard(selectCategoryAndType, setRateCardDetailsArr);
      setShowData(true);
    }
  };

  const onEditRateCard = (e, item) => {
    e.preventDefault();
    setRateCardDetails(item);
  };

  useEffect(() => {
    if (budgetApprovalRole) {
      if (budgetApprovalRole?.budgetApproverFound === false) {
        toast.error(
          "Budget approver role is not found! Please add budget approver role based on budget range"
        );
      } else {
        onDelete();
        // handleLogModalOpen();
      }
    }
  }, [budgetApprovalRole]);

  const onDeleteRateCard = (e, item) => {
    e.preventDefault();
    setTobeDeleted(item);
    handleLogModalOpen();
    // const data = [item]
    // fetchBudgetApprovalRole(setBudgetApprovalRole, data?.itemRate);
    // setTobeDeleted(item);
    // if (budgetApprovalRole?.budgetApproverFound === false) {
    //     toast.error("Budget approver role is not found! Please add budget approver role based on budget range")
    // }
    // else {
    //     setTobeDeleted(item);
    // }
  };

  const onSubmit = () => {
    if (!addComment || addComment.trim() === "") {
      toast.error("Please add comment!");
    } else if (!approvalBudget) {
      setErrorMessage({
        ...errorMessage,
        approvalBudgetError: "Please enter approval budget",
      });
    } else {
      fetchBudgetApprovalRole(setBudgetApprovalRole, approvalBudget);
      setErrorMessage({ ...errorMessage, approvalBudgetError: "" });
    }
  };

  const onDelete = () => {
    const formattedData = {
      id: tobeDeleted.id,
      mainTableId: tobeDeleted.id,
      vehicleType: tobeDeleted.vehicleType,
      sponsorshipFlag: tobeDeleted.sponsorshipFlag,
      dbsFlag: tobeDeleted.dbsFlag,
      category: tobeDeleted.category,
      routeName: tobeDeleted.routeName,
      itemType: tobeDeleted.itemType,
      urnNumber: tobeDeleted.urnNumber,
      validFrom: tobeDeleted.validFrom,
      validTo: tobeDeleted.validTo,
      landId: tobeDeleted.landId,
      vehicleId: tobeDeleted.vehicleId,
      itemRate: tobeDeleted.itemRate,
      unitPer: tobeDeleted.unitPer,
      transporterTableId: tobeDeleted.transporterTableId,
      isActive: tobeDeleted.isActive,
      createdBy: tobeDeleted.createdBy,
      createdOn: tobeDeleted.createdOn,
      background: tobeDeleted.background,
      justification: tobeDeleted.justification,
      finalSummary: tobeDeleted.finalSummary,
      documentName: tobeDeleted.documentName,
      documentGuid: tobeDeleted.documentGuid,
      operation: "DELETE",
      status: tobeDeleted.status,
      // mainTableId: tobeDeleted.id,
      approvalBudget: budgetApprovalRole?.budgetApproval,
      finalBudgetApprover: budgetApprovalRole?.budgetApproverRole,
      deletionComment: addComment,
      documents: tobeDeleted.documents,
    };
    setSubmitItem(formattedData);
    handleConfirmLogModalOpen();
  };

  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    handleLogModalClose();
    deleteRateCard(submitItem, setEditRateCardResponse);
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const onSaveRateCard = (e, index) => {
    e.preventDefault();
    editRateCard(rateCardDetails, setEditRateCardResponse);
    setFilterTable({
      ...filterTable,
      urnNumber: "",
      name: "",
      revenueCircle: "",
      lleName: "",
    });
  };

  const onCancelRateCard = (e, item) => {
    e.preventDefault();
    setRateCardDetails(null);
  };

  const columns = [
    { field: "urnNumber", headerName: STAKEHOLDER_URN, width: 150 },
    { field: "name", headerName: STAKEHOLDER_NAME, width: 150 },
    {
      field: "registrationNo",
      headerName: REGISTRATION_NO,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "HIT" ||
        (selectCategoryAndType?.itemType !== "Transportation Rate" && true),
    },
    {
      field: "vehicleType",
      headerName: VEHICLE_TYPE,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "HIT" ||
        (selectCategoryAndType?.itemType !== "Transportation Rate" && true),
    },
    {
      field: "vehicleCapacity",
      headerName: VEHICLE_CAPACITY,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "HIT" ||
        (selectCategoryAndType?.itemType !== "Transportation Rate" && true),
    },
    {
      field: "vehicleMake",
      headerName: VEHICLE_MAKE,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "HIT" ||
        (selectCategoryAndType?.itemType !== "Transportation Rate" && true),
    },
    {
      field: "vehicleModel",
      headerName: VEHICLE_MODEL,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "HIT" ||
        (selectCategoryAndType?.itemType !== "Transportation Rate" && true),
    },
    {
      field: "state",
      headerName: STATE,
      width: 150,
      hide: selectCategoryAndType?.category !== "LLE" && selectCategoryAndType?.category !== "Grower",
      renderCell: (params) => {
        return params?.row?.state && titleCase(params?.row?.state);
      },
    },
    {
      field: "district",
      headerName: DISTRICT,
      width: 150,
      hide: selectCategoryAndType?.category !== "LLE" && selectCategoryAndType?.category !== "Grower",
      renderCell: (params) => {
        return params?.row?.district && titleCase(params?.row?.district);
      },
    },
    {
      field: "toName",
      headerName: "Mapped Destination",
      width: 190,
      hide: selectCategoryAndType?.category !== "LLE" && selectCategoryAndType?.category !== "Grower",
    },
    {
      field: "routeName",
      headerName: ROUTE,
      width: 180,
      hide:
        selectCategoryAndType?.category !== "Transporter" &&
        selectCategoryAndType?.itemType !== "Transportation Rate",
    },
    {
      field: "landName",
      headerName: LAND_NAME,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "Grower" &&
        selectCategoryAndType?.itemType !== "Bamboo Rate",
    },
    {
      field: "validFrom",
      headerName: "Valid From",
      width: 150,
      renderCell: (params) => {
        return <>{format(new Date(params?.row?.validFrom), "dd/MM/yyyy")}</>;
      },
    },
    {
      field: "validTo",
      headerName: "Valid To",
      width: 150,
      renderCell: (params) => {
        return <>{format(new Date(params?.row?.validTo), "dd/MM/yyyy")}</>;
      },
    },
    {
      field: "revenueCircle",
      headerName: REVENUE_CIRCLE,
      width: 150,
      hide:
        selectCategoryAndType?.category !== "Grower" &&
        selectCategoryAndType?.itemType !== "Bamboo Rate",
    },
    { field: "itemRate", headerName: "Item Rate(in INR)", width: 140 },
    { field: "unitPer", headerName: "Unit Per", width: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Delete">
              <IconButton
                color="error"
                onClick={(e) => onDeleteRateCard(e, params.row)}
              >
                {" "}
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleTabChange = (e, newValue) => {
    e.preventDefault();
    setTabValue(newValue);
  };

  const handleTab2Change = (e, newValue) => {
    e.preventDefault();
    setTab2Value(newValue);
  };

  const handleUrnChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
    if (e.target.name === "urn") {
      setErrorMessage({ ...errorMessage, urnError: "" });
    }
  };

  const onProceedViewRateCardByUrn = (e) => {
    e.preventDefault();
    if (!details?.urn) {
      setErrorMessage({ ...errorMessage, urnError: "Please enter URN" });
    } else {
      fetchStakeholderRateCardStatus(details?.urn, setRateCardStatusResponse);
      setShowRateCardData(true);
    }
  };

  const PreviewClick = () => {
    if (!approvalBudget) {
      setErrorMessage({
        ...errorMessage,
        approvalBudgetError: "Please enter approval budget",
      });
    } else {
      fetchBudgetApprovalRole(setBudgetApprovalRole, approvalBudget);
      setErrorMessage({ ...errorMessage, approvalBudgetError: "" });
    }
  };

  useEffect(() => {
    if (rateCardStatusResponse) {
      if (rateCardStatusResponse?.isValidUrn !== null) {
        toast.error(rateCardStatusResponse?.isValidUrn);
      }
    }
  }, [rateCardStatusResponse]);

  const handleClose = () => {
    setOpen(false);
  };

  const hideCategory = rateCardStatusResponse?.rate?.every(r => r.category !== "Grower");

  const columnsRateCard = [
    { field: "urnNumber", headerName: STAKEHOLDER_URN, width: 150 },
    { field: "name", headerName: STAKEHOLDER_NAME, width: 150 },
    {
      field: "state",
      headerName: STATE,
      width: 150,
      hide: hideCategory,
      renderCell: (params) => {
        return params?.row?.state && titleCase(params?.row?.state);
      },
    },
    {
      field: "district",
      headerName: DISTRICT,
      width: 150,
      hide: hideCategory,
      renderCell: (params) => {
        return params?.row?.district && titleCase(params?.row?.district);
      },
    },
    {
      field: "toName",
      headerName: "Mapped Destination",
      width: 190,
      hide: hideCategory,
    },
    {
      field: "validFrom",
      headerName: "Valid From",
      width: 130,
      renderCell: (params) => {
        return <>{format(new Date(params?.row?.validFrom), "dd/MM/yyyy")}</>;
      },
    },
    {
      field: "validTo",
      headerName: "Valid To",
      width: 130,
      type: "dateTime",
      renderCell: (params) => {
        return <>{format(new Date(params?.row?.validTo), "dd/MM/yyyy")}</>;
      },
    },
    { field: "itemType", headerName: "Item Type", width: 150 },
    { field: "itemRate", headerName: "Item Rate(in INR)", width: 140 },
    { field: "unitPer", headerName: "Unit Per", width: 100 },
    {
      field: "isExpired",
      headerName: "Expired",
      width: 120,
      renderCell: (params) => {
        return params?.row?.isExpired === "Y" ? "Yes" : "No";
      },
    },
    {
      field: "isActive",
      headerName: "Active",
      width: 100,
      renderCell: (params) => {
        return params?.row?.isActive === "Y" ? "Yes" : "No";
      },
    },
  ];

  const viewworklist = [
    {
      field: "requestNumber",
      headerName: "Request No/Approval Note No",
      width: 250,
    },
    { field: "workflowType", headerName: "Request Type", width: 220 },
    { field: "stakeholderType", headerName: "StakeHolder Type", width: 240 },
    { field: "currentStatus", headerName: "Status", width: 180 },
    { field: "currentOwner", headerName: "Current Owner", width: 200 },
    { field: "createdBy", headerName: "Created By", width: 220 },
    { field: "updatedBy", headerName: "Action Taken By", width: 220 },
    { field: "approvedBy", headerName: "Approved By", width: 220 },
  ];

  const handleApprovalBudget = (e) => {
    setApprovalBudget(e.target.value);
    setErrorMessage({ ...errorMessage, approvalBudgetError: "" });
  };

  const sortRowsByLatestIdAndDate = (rows) => {
    // Step 1: find latest date for each ID
    const latestDateMap = {};

    rows?.forEach((row) => {
      const date = new Date(row.validTo);
      const id = row.urnNumber;

      if (!latestDateMap[id] || date > latestDateMap[id]) {
        latestDateMap[id] = date;
      }
    });

    // Step 2: sort rows
    return [...rows].sort((a, b) => {
      const latestA = latestDateMap[a.urnNumber];
      const latestB = latestDateMap[b.urnNumber];

      // Order ID groups by latest date (DESC)
      if (latestA.getTime() !== latestB.getTime()) {
        return latestB - latestA;
      }

      // Same ID → latest date first
      if (a.urnNumber === b.urnNumber) {
        return new Date(b.validTo) - new Date(a.validTo);
      }

      // Final fallback (stable)
      return a.urnNumber.localeCompare(b.urnNumber);
    });
  };

  const sortRowsByLatestIdAndDateForRateStatus = (rows) => {
    // Step 1: find latest date for each ID
    const latestDateMap = {};

    rows?.forEach((row) => {
      const date = new Date(row.validTo);
      const id = row.urnNumber;

      if (!latestDateMap[id] || date > latestDateMap[id]) {
        latestDateMap[id] = date;
      }
    });

    // Step 2: sort rows
    return [...rows].sort((a, b) => {
      const latestA = latestDateMap[a.urnNumber];
      const latestB = latestDateMap[b.urnNumber];

      // Order ID groups by latest date (DESC)
      if (latestA.getTime() !== latestB.getTime()) {
        return latestB - latestA;
      }

      // Same ID → latest date first
      if (a.urnNumber === b.urnNumber) {
        return new Date(b.validTo) - new Date(a.validTo);
      }

      // Final fallback (stable)
      return a.urnNumber.localeCompare(b.urnNumber);
    });
  };

  const sortedRows = sortRowsByLatestIdAndDate(rateCardDetailsArr);

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className="pageNumberingResc">RES18</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} />
          <Typography variant="h5" gutterBottom>
            {VIEW_OR_EDIT_RATE_CARD}
          </Typography>
        </Stack>
        <Card>
          <TabContext value={tabValue}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                bgcolor: "whitesmoke",
              }}
            >
              <TabList
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Search by Category & ItemType" value="0" />
                <Tab label="Search by Stakeholder URN" value="1" />
              </TabList>
            </Box>
            <TabPanel value="0">
              <Grid container spacing={1}>
                <Grid item xs={12} lg={3}>
                  <FormControl
                    sx={{ width: "100%", paddingRight: "3%" }}
                    error={submit && !selectCategoryAndType?.category}
                  >
                    <InputLabel id="selectstakeholder-label">
                      {CATEGORY}
                    </InputLabel>
                    <Select
                      label={CATEGORY}
                      name="category"
                      value={selectCategoryAndType?.category || ""}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem>
                        <em>{CATEGORY}</em>
                      </MenuItem>
                      {categoryList
                        ?.filter((filterItem) => filterItem !== "ABEPL Plant")
                        ?.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>
                      {errorMessage?.categoryError?.CATEGORY_ERROR}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <FormControl
                    sx={{ width: "100%", paddingRight: "3%" }}
                    error={submit && !selectCategoryAndType?.itemType}
                  >
                    <InputLabel id="mappedstakeholder-label">
                      {ITEM_TYPE}
                    </InputLabel>
                    <Select
                      label={ITEM_TYPE}
                      name="itemType"
                      value={selectCategoryAndType?.itemType || ""}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem>
                        <em>{ITEM_TYPE}</em>
                      </MenuItem>
                      {selectCategoryAndType?.category &&
                        itemTypeList[selectCategoryAndType?.category]
                          ?.filter((item) => item !== "Gate Price")
                          ?.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                    </Select>
                    <FormHelperText>
                      {errorMessage?.itemTypeError?.ITEM_TYPE_ERROR}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Button
                    endIcon={<ProceedIcon />}
                    sx={{ minWidth: 100 }}
                    className="RescProceed"
                    variant="contained"
                    onClick={(e) => onProceedViewRateCardTable(e)}
                  >
                    {PROCEED}
                  </Button>
                </Grid>
              </Grid>
              {showData && rateCardDetailsArr && (
                <Grid container mt={2}>
                  <DataGrid
                    autoHeight
                    columns={columns}
                    rows={sortedRows}
                    pageSize={10}
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{
                      toolbar: {
                        rows: sortedRows,
                        columns: columns,
                        fileName: "RateCard.xlsx",
                        isExportToExcelRequired: true
                      },
                    }}
                  />
                </Grid>
              )}
            </TabPanel>
            <TabPanel value="1">
              <Grid container spacing={1} mb={2}>
                <Grid item xs={12} lg={3}>
                  <TextField
                    fullWidth
                    error={errorMessage.urnError}
                    helperText={errorMessage.urnError}
                    label="URN"
                    name="urn"
                    value={details?.urn}
                    onChange={(e) => handleUrnChange(e)}
                    inputProps={{
                      maxLength: 20,
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "_" ||
                        evt.key === "-" ||
                        evt.key === "," ||
                        evt.key === "+" ||
                        evt.key === "!" ||
                        evt.key === "@" ||
                        evt.key === "#" ||
                        evt.key === "$" ||
                        evt.key === "%" ||
                        evt.key === "^" ||
                        evt.key === "&" ||
                        evt.key === "*" ||
                        evt.key === "(" ||
                        evt.key === ")") &&
                      evt.preventDefault()
                    }
                  />
                  <BadgeComponent
                    currentLength={details?.urn?.length}
                    maxLength={urnMaxLength}
                  />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Button
                    endIcon={<ProceedIcon />}
                    sx={{ minWidth: 100 }}
                    className="RescProceed"
                    variant="contained"
                    onClick={(e) => onProceedViewRateCardByUrn(e)}
                  >
                    {PROCEED}
                  </Button>
                </Grid>
              </Grid>
              {showRateCardData && rateCardStatusResponse && (
                <Card>
                  <TabContext value={tab2Value}>
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        bgcolor: "whitesmoke",
                      }}
                    >
                      <TabList
                        onChange={handleTab2Change}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Rate Card Status" value="rateCardStatus" />
                        <Tab label="Workflow Status" value="workflowStatus" />
                      </TabList>
                    </Box>
                    <TabPanel value="rateCardStatus">
                      <Box sx={{ height: 450, width: "100%" }}>
                        <DataGrid
                          columns={columnsRateCard}
                          rows={rateCardStatusResponse?.rate}
                          pageSize={10}
                          rowsPerPageOptions={[5]}
                          components={{
                            Toolbar: CustomDataGridToolbar,
                          }}
                          initialState={{
                            sorting: {
                              sortModel: [
                                {
                                  field: "validTo",
                                  sort: "desc", // latest first
                                },
                              ],
                            },
                          }}
                          componentsProps={{
                            toolbar: {
                              rows: rateCardStatusResponse?.rate,
                              columns: columnsRateCard,
                              fileName: "RateCardStatus.xlsx",
                              isExportToExcelRequired: true
                            },
                          }}
                        />
                      </Box>
                    </TabPanel>
                    <TabPanel value="workflowStatus">
                      <Box sx={{ height: 450, width: "100%" }}>
                        <DataGrid
                          rows={rateCardStatusResponse?.workflowRequestListPojo}
                          columns={viewworklist}
                          pageSize={10}
                          rowsPerPageOptions={[5]}
                          getRowId={(row) => row?.requestNumber}
                          initialState={{
                            sorting: {
                              sortModel: [
                                { field: "requestNumber", sort: "desc" },
                              ],
                            },
                          }}
                          components={{
                            Toolbar: CustomDataGridToolbar,
                          }}
                          componentsProps={{
                            toolbar: {
                              rows: rateCardStatusResponse?.workflowRequestListPojo,
                              columns: viewworklist,
                              fileName: "WorkLogList.xlsx",
                            },
                          }}
                        />
                      </Box>
                    </TabPanel>
                  </TabContext>
                </Card>
              )}
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
      <ConfirmationPopover
        onOpen={logConfirmModalOpen}
        onConfirm={onConfirmCallBack}
        onClose={onCancelBack}
        action="Delete"
      />
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: 600, height: 350 } }}
        open={logModalOpen}
      >
        <DialogTitle>Add Comment</DialogTitle>
        <Typography></Typography>
        <DialogContent>
          <TextField
            fullWidth
            required
            // error={errorMessage.bidError}
            // helperText={errorMessage.bidError}
            type="text"
            label="Comment"
            name="comment"
            multiline
            rows={4}
            onChange={(e) =>
              setAddComment(
                VALIDATION.noSpecialCharacterValidation(e.target.value)
              )
            }
            value={addComment}
          />
          <Grid item xs={12} lg={5.8} mt={1}>
            <Typography variant="subtitle2" gutterBottom>
              Approval Budget(in INR):
            </Typography>
            {/* <TextField fullWidth value={state?.budget?.budgetApproval ? state?.budget?.budgetApproval : state?.addedRateCardDetailsArr?.[0]?.approvalBudget} disabled /> */}
            {/* <TextField fullWidth value={totalRate} disabled /> */}
            <TextField
              required
              fullWidth
              onFocus={handleNumberFieldFocus}
              error={errorMessage.approvalBudgetError}
              helperText={errorMessage.approvalBudgetError}
              type="number"
              value={
                state?.addedRateCardDetailsArr?.[0]?.approvalBudget
                  ? state?.addedRateCardDetailsArr?.[0]?.approvalBudget
                  : approvalBudget
              }
              onChange={(e) => handleApprovalBudget(e)}
              disabled={
                state?.addedRateCardDetailsArr?.[0]?.approvalBudget
                  ? true
                  : false
              }
              onKeyDown={(evt) =>
                (evt.key === "e" ||
                  evt.key === "E" ||
                  evt.key === "-" ||
                  evt.key === "+") &&
                evt.preventDefault()
              }
            />
          </Grid>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: "1vh",
            }}
          >
            <Badge
              bg={`${addComment.length > characterLimit ? "danger" : "primary"
                }`}
            >
              {addComment.length}/{characterLimit}
            </Badge>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose}>Cancel</Button>
          <Button onClick={(e) => onSubmit(e)}>Submit</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default EditRateCard;
